import React from 'react';
import Image from 'next/image';
import useTranslation from 'next-translate/useTranslation';
import Skeleton from 'react-loading-skeleton';

import { ActiveLink, Button } from '@/ui/index';
import { BrandArrow } from '@/icons/index';

import styles from './NewsItem.module.scss';

const NewsItem = ({
  data: { image = '', title = '', description = '', slug = '', category },
}) => {
  const { t } = useTranslation();
  const [isImageLoaded, setIsImageLoaded] = React.useState(false);

  return (
    <div
      className={styles.newsItem}
      itemScope
      itemType='https://schema.org/NewsArticle'
    >
      <ActiveLink href={`/news/${slug}`}>
        <a>
          <div className={styles.imageContainer}>
            {!!image && (
              <>
                {!isImageLoaded && <Skeleton width='100%' height='100%' />}
                <Image
                  src={image}
                  alt={title}
                  title={title}
                  layout={'fill'}
                  loading='lazy'
                  onLoadingComplete={() => setIsImageLoaded(true)}
                  style={{
                    visibility: isImageLoaded ? 'visible' : 'hidden',
                  }}
                />
              </>
            )}
          </div>
          <div className={styles.textWrapper}>
            {!!category && <div className={styles.category}>{category}</div>}
            {!!title && <div className={styles.title}>{title}</div>}
            {!!description && (
              <div
                className={styles.description}
                dangerouslySetInnerHTML={{ __html: description }}
              />
            )}
          </div>
        </a>
      </ActiveLink>
      <Button
        variant='transparent'
        Component={'router'}
        href={`/news/${slug}`}
        className={styles.see_more__btn}
      >
        {t('common:See more')}
        <BrandArrow width={26} />
      </Button>
    </div>
  );
};

export default NewsItem;
